import React from 'react';
import { Button, Checkbox, Flex, Modal, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const Desktop = ({ viewModel, disabled, buttonText }) => (
  <>
    <Button onClick={viewModel.openSheet} disabled={disabled}>
      {buttonText}
    </Button>

    <Modal
      title='Chọn thuộc tính'
      open={viewModel.open}
      onCancel={viewModel.closeSheet}
      footer={
        <Flex justify='flex-end' gap={8}>
          <Button onClick={viewModel.closeSheet}>Đóng</Button>
          <Button type='primary' onClick={viewModel.apply}>Xác nhận</Button>
        </Flex>
      }
    >
      <Space direction='vertical' size={12} style={{ width: '100%' }}>
        <Flex justify='space-between' align='center'>
          <div style={{ fontWeight: 600 }}>Chọn thuộc tính</div>
          <Button type='link' icon={<PlusOutlined />} loading={viewModel.creating} onClick={viewModel.createNewAttribute}>
            Thêm mới
          </Button>
        </Flex>
        <Space direction='vertical' size={8} style={{ width: '100%' }}>
          {viewModel.optionDefs.map((opt) => (
            <Checkbox
              key={opt.id}
              checked={viewModel.selectedIds.includes(String(opt.id))}
              disabled={!viewModel.selectedIds.includes(String(opt.id)) && viewModel.selectedIds.length >= 2}
              onChange={(e) => viewModel.onToggleAttribute(opt.id, e.target.checked)}
            >
              {opt.title}
            </Checkbox>
          ))}
        </Space>
      </Space>
    </Modal>
  </>
);

export default Desktop;
